/**
 * TPL Multi-state Badge — motion.dev "Multi state badge" port.
 * Morphs an inline pill between states: the old text lifts out, the pill's
 * width eases to fit the new text, the new text drops in, and the state class
 * (which colours the dot) swaps. Generic: any element can be morphed.
 *
 * Used by tpl-product-page.js for the limited-edition count on variant change
 * ("12 of 30 remaining" → "Only 3 of 30 remaining" → "Sold out").
 */
(function () {
  'use strict';

  var EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var OUT_MS = 140;
  var WIDTH_MS = 420;
  var IN_MS = 260;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function supported() {
    return typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
  }

  function apply(el, next) {
    if (typeof next.text === 'string') el.textContent = next.text;
    if (typeof next.className === 'string') el.className = next.className;
  }

  /* Returns true when a morph animation ran, false when the state was applied instantly. */
  function morph(el, next) {
    if (!el || !next) return false;
    var sameText = typeof next.text !== 'string' || el.textContent.trim() === next.text.trim();
    var sameClass = typeof next.className !== 'string' || el.className === next.className;
    if (sameText && sameClass) return false;
    if (!supported() || reducedMotion() || sameText) { apply(el, next); return false; }

    var w0 = el.getBoundingClientRect().width;
    var text = el.firstChild && el.firstChild.nodeType === 3 ? el : null;   // plain text pill
    var out = el.animate([{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-6px)' }], { duration: OUT_MS, easing: 'ease-in', fill: 'forwards' });
    out.onfinish = function () {
      apply(el, next);
      var w1 = el.getBoundingClientRect().width;
      el.animate([{ width: w0 + 'px' }, { width: w1 + 'px' }], { duration: WIDTH_MS, easing: EXPO });
      el.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: IN_MS, easing: EXPO, fill: 'forwards' });
    };
    return true;
  }

  window.TPLMultiStateBadge = { morph: morph };
})();
